<template>
  <dragPanel
    title="纹理动画"
    :closePanel="closePanel"
    :tooltipVisible="false"
    class="common-drag-panel">
    <div
      v-if="isLoaded"
      class="texture-loaded-box">
      <div
        v-if="isTextureExist()"
        class="common-empty-box">
        <bj-empty
          :image="require('@/assets/img/no-data.png')"
          class="empty-page">
          <template slot="description">
            <div>
              当前{{ type === 'DataSet' ? '数据集' : '场景' }}没有纹理动画
            </div>
          </template>
        </bj-empty>
      </div>
      <div
        v-else
        class="texture-box">
        <div class="common-tree-box">
          <el-tree
            class="dialog-tree-primary"
            ref="textureTree"
            :data="textureData"
            :props="defaultProps"
            :default-checked-keys="['all']"
            node-key="nodeId"
            highlight-current
            show-checkbox
            default-expand-all
            :expand-on-click-node="false"
            @node-click="handleNodeClick">
            <div
              slot-scope="{ data }"
              class="custom-node-box">
              <div class="node-content-box">
                <div
                  class="text-overflow"
                  :title="data.nodeName">
                  {{ data.nodeName }}
                </div>
                <div
                  v-show="data.nodeId === 'all'"
                  class="custom-button-box">
                  <el-button
                    type="text"
                    size="small"
                    @click="e => batchToggleViewTexture(data, e)"
                    :title="`${batchView ? '批量隐藏' : '批量显示'}`">
                    <icon-svg
                      v-if="batchView"
                      icon-class="ic-xianshi1"
                      class="icon" />
                    <icon-svg
                      v-else
                      icon-class="ic-a-yincang1"
                      class="icon" />
                  </el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click="e => batchStop(data, e)"
                    :title="`${batchPaly ? '批量停止' : '批量播放'}`">
                    <icon-svg
                      v-if="batchPaly"
                      icon-class="ic-bofang1"
                      class="icon" />
                    <icon-svg
                      v-else
                      icon-class="ic-zanting1"
                      class="icon" />
                  </el-button>
                </div>
                <div
                  v-show="data.isPath"
                  class="custom-button-box">
                  <el-button
                    type="text"
                    size="small"
                    @click="e => toggleViewTexture(data, e)"
                    :title="`${data.isView ? '隐藏' : '显示'}`">
                    <icon-svg
                      v-if="data.isView"
                      icon-class="ic-xianshi1"
                      class="icon" />
                    <icon-svg
                      v-else
                      icon-class="ic-a-yincang1"
                      class="icon" />
                  </el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click="e => stopUVAnim(data, e)"
                    :title="`${data.isPlay ? '停止' : '播放'}`">
                    <icon-svg
                      v-if="data.isPlay"
                      icon-class="ic-bofang1"
                      class="icon" />
                    <icon-svg
                      v-else
                      icon-class="ic-zanting1"
                      class="icon" />
                  </el-button>
                </div>
              </div>
            </div>
          </el-tree>
        </div>
      </div>
    </div>
  </dragPanel>
</template>

<script>
import dragPanel from '@/components/CustomDragPanel.vue'

import {
  getSharedSceneById,
  getSharedProjectSceneTree,
  getSharedTextureList
} from '@/service/interface'

export default {
  data() {
    return {
      batchView: true,
      batchPaly: true,
      isLoaded: false,
      textureData: [],
      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      },
      selectedPath: {},
      selectedPaths: []
    }
  },
  props: {
    type: String,
    modelInfo: Array,
    closePanel: Function
  },
  components: {
    dragPanel
  },
  mounted() {
    this.initTextureData()
  },
  methods: {
    initTextureData() {
      if (this.type === 'DataSet') {
        this.initDataSetTexture()
      } else {
        this.initSceneTexture()
      }
    },
    initDataSetTexture() {
      let dataSetId = this.$route.params.resourceId
      let headers = this.getHeaders()
      let params = { dataSetId }
      getSharedTextureList(params, { headers }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let appliedData = data.filter(el => el.isApplied && !el.removeStatus)
          appliedData = this.formatData(appliedData)
          if (appliedData.length) {
            let textureData = [
              { nodeId: 'all', nodeName: '全部', subNodes: appliedData }
            ]
            this.textureData = textureData
          }

          this.isLoaded = true
        }
      })
    },
    initSceneTexture() {
      let promiseArray = []
      let sceneId = this.$route.params.resourceId
      let headers = this.getHeaders()
      this.initSceneData().then(dataSets => {
        dataSets.forEach(item => {
          let params = { dataSetId: item.dataSetId }
          let promise = getSharedTextureList(params, {
            headers
          })
          promiseArray.push(promise)
        })

        Promise.all(promiseArray).then(response => {
          response.forEach((item, index) => {
            if (item.isSuccess) {
              let appliedData = item.data.filter(
                el => el.isApplied && !el.removeStatus
              )
              appliedData = this.formatData(appliedData)
              dataSets[index].subNodes = appliedData
            }
          })

          dataSets = dataSets.filter(el => el.subNodes.length)
          let textureData = [
            {
              nodeId: 'all',
              nodeName: '全部',
              subNodes: dataSets
            }
          ]
          this.textureData = textureData
          this.isLoaded = true
        })
      })
    },
    initSceneData() {
      return new Promise(resolve => {
        let sceneId = this.$route.params.resourceId
        let headers = this.getHeaders()
        getSharedSceneById(sceneId, { headers }).then(response => {
          if (response.isSuccess) {
            getSharedProjectSceneTree({ sceneId }, { headers }).then(res => {
              if (res.isSuccess) {
                let data = res.data
                let dataSets = data.subNodes.filter(el => el.viewStatus !== 2)
                dataSets = dataSets.map(item => {
                  let obj = {
                    dataSetId: item.dataSetId,
                    nodeId: item.sceneNodeId,
                    nodeName: item.sceneNodeName,
                    subNodes: []
                  }
                  return obj
                })
                resolve(dataSets)
              }
            })
          }
        })
      })
    },
    handleNodeClick(nodeData) {
      if (nodeData.isPath) {
        let Camera = window.BlackHole3D.Camera
        let dataSetId = nodeData.dataSetId
        let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
        let resId = find.resId
        Camera.setCamLocateToElem(
          [
            {
              dataSetId: resId,
              elemIdList: nodeData.elements
            }
          ],
          1.0
        )
      }
    },
    batchToggleViewTexture(nodeData, e) {
      e.stopPropagation()
      let checkData = this.$refs.textureTree.getCheckedNodes(true)
      if (nodeData.nodeId === 'all') {
        checkData = checkData.filter(el => el.isPath)
      } else {
        checkData = checkData.filter(el => el.dataSetId === nodeData.dataSetId)
      }
      this.selectedPaths = checkData

      if (!this.selectedPaths.length) {
        this.$message.warning('请先选择需要批量操作的数据')
        return
      }

      this.selectedPaths.forEach(item => {
        let BlackHole3D = window.BlackHole3D
        let dataSetId = item.dataSetId
        let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
        let resId = find.resId

        let anim = new BlackHole3D.REElemUVAnim()
        anim.dataSetId = resId
        anim.elemIdList = item.elements

        if (this.batchView) {
          anim.scale = [0, 0]
          anim.speed = [0.0, 0.0]
        } else {
          let scale = Number((1 / item.compressionRatio).toFixed(2))
          anim.scale = [scale, 1]
          if (item.isPlay) {
            let speed = item.direction > 0 ? item.flowRate : -item.flowRate
            anim.speed = [speed, 0]
          }
        }
        BlackHole3D.BIM.setElemUVAnimAttr(anim)

        item.isView = !this.batchView
      })

      this.batchView = !this.batchView
    },
    toggleViewTexture(nodeData, e) {
      e.stopPropagation()
      let BlackHole3D = window.BlackHole3D
      let dataSetId = nodeData.dataSetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId

      let anim = new BlackHole3D.REElemUVAnim()
      anim.dataSetId = resId
      anim.elemIdList = nodeData.elements
      if (nodeData.isView) {
        anim.scale = [0, 0]
        anim.speed = [0.0, 0.0]
      } else {
        let scale = Number((1 / nodeData.compressionRatio).toFixed(2))
        anim.scale = [scale, 1]
        if (nodeData.isPlay) {
          let speed =
            nodeData.direction > 0 ? nodeData.flowRate : -nodeData.flowRate
          anim.speed = [speed, 0]
        }
      }
      BlackHole3D.BIM.setElemUVAnimAttr(anim)

      nodeData.isView = !nodeData.isView

      let textureData = []
      if (this.type === 'DataSet') {
        textureData = this.textureData[0].subNodes
        this.batchView = textureData.some(el => el.isView)
      } else {
        this.textureData[0].subNodes.forEach(item => {
          textureData = [...item.subNodes, ...textureData]
        })
        this.batchView = textureData.some(el => el.isView)
      }
    },
    batchStop(nodeData, e) {
      e.stopPropagation()
      let checkData = this.$refs.textureTree.getCheckedNodes(true)
      if (nodeData.nodeId === 'all') {
        checkData = checkData.filter(el => el.isPath)
      } else {
        checkData = checkData.filter(el => el.dataSetId === nodeData.dataSetId)
      }
      this.selectedPaths = checkData

      if (!this.selectedPaths.length) {
        this.$message.warning('请先选择需要批量操作的数据')
        return
      }

      let BlackHole3D = window.BlackHole3D

      this.selectedPaths.forEach(item => {
        let find = this.modelInfo.find(el => el.dataSetId === item.dataSetId)
        let resId = find.resId

        let anim = new BlackHole3D.REElemUVAnim()
        anim.dataSetId = resId
        anim.elemIdList = item.elements
        let scale = Number((1 / item.compressionRatio).toFixed(2))
        anim.scale = [scale, 1]

        if (this.batchPaly) {
          anim.speed = [0.0, 0.0]
        } else {
          let speed = item.direction > 0 ? item.flowRate : -item.flowRate
          anim.speed = [speed, 0]
        }

        BlackHole3D.BIM.setElemUVAnimAttr(anim)

        item.isPlay = !this.batchPaly
      })

      this.batchPaly = !this.batchPaly
    },
    stopUVAnim(nodeData, e) {
      e.stopPropagation()
      let BlackHole3D = window.BlackHole3D
      let dataSetId = nodeData.dataSetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId

      let anim = new BlackHole3D.REElemUVAnim()
      anim.dataSetId = resId
      anim.elemIdList = nodeData.elements
      let scale = Number((1 / nodeData.compressionRatio).toFixed(2))
      anim.scale = [scale, 1]
      if (nodeData.isPlay) {
        anim.speed = [0.0, 0.0]
      } else {
        let speed =
          nodeData.direction > 0 ? nodeData.flowRate : -nodeData.flowRate
        anim.speed = [speed, 0]
      }

      nodeData.isPlay = !nodeData.isPlay

      BlackHole3D.BIM.setElemUVAnimAttr(anim)

      let textureData = []
      if (this.type === 'DataSet') {
        textureData = this.textureData[0].subNodes
        this.batchPaly = textureData.some(el => el.isPlay)
      } else {
        this.textureData[0].subNodes.forEach(item => {
          textureData = [...item.subNodes, ...textureData]
        })
        this.batchPaly = textureData.some(el => el.isPlay)
      }
    },
    isTextureExist() {
      let isEmpty = true
      if (this.type === 'DataSet') {
        if (this.textureData.length) {
          isEmpty = false
        }
      } else {
        let textureData = this.textureData[0].subNodes
        let flag = textureData.some(el => el.subNodes.length)
        if (flag) {
          isEmpty = false
        }
      }

      return isEmpty
    },
    formatData(data) {
      data.forEach(item => {
        item.nodeId = item.id
        item.nodeName = item.name
        item.subNodes = []
        item.isPath = true
        item.isPlay = true
        item.isView = true
      })
      return data
    },
    getHeaders() {
      let token = this.$route.query.token
      let headers = {
        Authorization: token
      }
      return headers
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  right: 20px;
  top: 150px;
  width: 360px;
  height: calc(100% - 225px);
  min-width: 320px;
  min-height: 300px;

  /deep/ .content {
    position: relative;
    height: calc(100% - 40px);

    .texture-loaded-box {
      height: 100%;
    }

    .common-empty-box {
      margin-top: -20px;

      .common-button-box {
        margin-top: 20px;

        // .el-button {
        //   padding: 10px 40px;
        // }
      }
    }

    .texture-box {
      height: 100%;

      .common-tree-box {
        padding: 5px 10px;
        height: calc(100% - 50px);
        .custom-node-box {
          width: calc(100% - 45px);

          .node-content-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 400;

            .custom-button-box {
              margin: 0px 5px;
              .el-button {
                margin-right: 0px;
                padding: 0px;
              }

              .icon {
                font-size: 14px;
                color: var(--default-color);
              }
            }
          }
        }
      }
    }
  }
}
</style>
